import React, { use, useEffect, useState, useRef } from "react";
import axios from "axios";
import { set, useForm } from "react-hook-form";
import { useOutletContext, useNavigate } from "react-router-dom";
import $ from "jquery";
import { Client_View } from "../../utils/sweetalert";
import toastr from "../../utils/toast";
import Select from "react-select";

function EditClient({ onClose, clientId }) {
  const { setGlobalLoading, token } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();

  const client_id = useRef();

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  const [companies, setCompanies] = useState([]);
  const [countries, setCountries] = useState([]);
  const [majorIndustries, setMajorIndustries] = useState([]);
  const [minorIndustries, setMinorIndustries] = useState([]);
  const [users, setUsers] = useState([]);
  const [peVcReferred, setpeVcReferred] = useState([]);
  const [showOthergroupedCompany, setshowOthergroupedCompany] = useState(false);
  const [clientTypes, setClientTypes] = useState([]);
  const [existClient, setexistClient] = useState({
    company: null,
    companydetails: null,
    companyinfos: null,
  });

  let groupedCompanyOption = watch("groupedCompanyOption");

  const searchTimeout = useRef(null);
  const lastSelectedRef = useRef(null);

  const [companyInfoOptions, setCompanyInfoOptions] = useState([]);
  const [selectedCompanyInfo, setSelectedCompanyInfo] = useState(null);

  async function fetchClientData() {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/clients/getclient_details/${clientId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = res.data;
      console.log(data);
      setexistClient({
        company: data.company?.[0] || null,
        companydetails: data.companydetails?.[0] || null,
        companyinfos: data.companyinfos?.[0] || null,
      });
    } catch (error) {
      console.error("Error fetching form data:", error);
      setGlobalLoading(false);
    }
  }

  useEffect(() => {
    if (client_id.current) return;
    client_id.current = clientId;
    fetchClientData();
  }, [clientId]);

  useEffect(() => {
    if (existClient.company === null) return;

    const company = existClient.company;
    const companyinfos = existClient.companyinfos || null;

    setValue("reference", company.reference);
    setValue("companies", company.name);
    setValue("id", company.id);
    const setindustries = async () => {
      let major_id;
      majorIndustries.map((m) => {
        if (m.id === company.industrymaster_id) {
          setValue("industrymaster_id", m.id);
          major_id = m.id;
        }
      });
      await fetchMinorIndustry({ target: { value: major_id } });
    };
    setindustries();
    minorIndustries.map((m) => {
      if (m.id === company.industry_id) {
        setValue("industry_id", m.id);
      }
    });

    if (company.group_id !== null) {
      setValue("groupedCompanyOption", "yes");
      setValue("groupedCompany", company.group_id);
      showgroupedCompanyOther(company.group_id);
    } else {
      setValue("groupedCompanyOption", "no");
    }

    if (company.private_equity === "yes") {
      setpeVcReferredOption("yes");

      if (company.companyinfo_id) {
        // 1️⃣ Create the option dynamically
        setSelectedCompanyInfo({
          value: companyinfos.id,
          label: companyinfos.name,
        });

        // 3️⃣ Update form value
        setValue("companyinfo_id", company.companyinfo_id);
      }
    } else {
      setpeVcReferredOption("no");
    }
    // if (company.private_equity === "yes") {
    //   setpeVcReferredOption("yes");

    //   if (company.companyinfo_id) {
    //     // 1️⃣ Create the option dynamically
    //     const option = new Option(
    //       companyinfos.name || "Loaded Option", // visible text
    //       companyinfos.id, // value
    //       true, // defaultSelected
    //       true, // selected
    //     );

    //     // 2️⃣ Append and trigger Select2 update
    //     const $select2 = $('[name="companyinfo_id"]');
    //     $select2.append(option).trigger("change.select2");

    //     // 3️⃣ Update your form value
    //     setValue("companyinfo_id", company.companyinfo_id);
    //   }
    // }
    //  else {
    //   setpeVcReferredOption("no");
    // }
  }, [existClient, majorIndustries]);

  // Fetch dropdown data once on mount
  useEffect(() => {
    async function fetchAllDropdownData() {
      //  Show loader before API call
      try {
        const res = await axios.get(`${API_BASE_URL}/clients/clientd`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = res.data;
        setCompanies(data.companies || []);
        setCountries(data.countries || []);
        setMajorIndustries(data.majorIndustry || []);
        setUsers(data.users || []);
        setClientTypes(data.client_type || []);
      } catch (error) {
        console.error("Error fetching form data:", error);
      }
    }
    fetchAllDropdownData();
  }, [token, API_BASE_URL]);

  const clearSelect = () => {
    setValue("website", "");
    setValue("companies", ""); // clear react-hook-form value
    setValue("industrymaster_id", "");
    setValue("industry_id", "");
    setValue("companyinfo_id", "");
  };

  useEffect(() => {
    try {
      setGlobalLoading(true);
      const company = existClient.company;
      const companydetails = existClient.companydetails;
      setValue("website", companydetails.website);
      const minor = minorIndustries.find((m) => m.id === company.industry_id);
      if (minor) {
        setValue("industry_id", minor.id || "");
      }
      setValue("clientType", companydetails?.clienttype_id);
      users.map((u) => {
        if (u.id === companydetails?.businessDeveloped_id) {
          setValue("businessDeveloped_id", u.id);
        }
        if (u.id === companydetails?.bdinfluence) {
          setValue("bdInfluence", u.id);
        }
        if (u.id === companydetails?.clientManaged_id) {
          setValue("clientManaged_id", u.id);
        }
      });
      setValue("origin", company?.origin);
      setValue("gcc", company?.gcc || "no");
    } catch (error) {
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  }, [existClient, minorIndustries, clientTypes, users]);

  const onSubmit = async (data) => {
    // console.log(data);
    // return;
    setGlobalLoading(true);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/clients/edit_client`,
        { data },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      onClose();
      toastr.success("Client Updated Successfully");
    } catch (err) {
      setGlobalLoading(false);
      console.error("Submission failed:", err);
      alert("Error submitting form.");
    } finally {
      setGlobalLoading(false);
    }
  };

  // ############################################################

  const fetchMinorIndustry = async (e) => {
    const id = e.target.value;
    try {
      const response = await axios.get(
        `${API_BASE_URL}/common_controller/get_minor_industries_by_maji_id/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setMinorIndustries(response.data.minor_industries || []);
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  // const PEPV = async() => {
  async function PEPV(keyword) {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/clients/companyLoad`,
        { keywords: keyword },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = response.data.options;
      setCompanyInfoOptions(data);
    } catch (error) {
      console.log(error);
    } finally {
    }

    // $select2.select2({
    //   multiple: false,
    //   closeOnSelect: true,
    //   tags: true, // ✅ allow typed custom entries
    //   dropdownParent: $(".add_client"),
    //   createTag: function (params) {
    //     return {
    //       id: params.term,
    //       text: params.term,
    //       custom: true,
    //     };
    //   },
    //   ajax: {
    //     type: "POST",
    //     url: `${API_BASE_URL}/clients/companyLoad`,
    //     dataType: "json",
    //     contentType: "application/json",
    //     delay: 250,
    //     beforeSend: function (xhr) {
    //       xhr.setRequestHeader("Authorization", `Bearer ${token}`);
    //     },
    //     data: function (params) {
    //       return JSON.stringify({ keywords: params.term });
    //     },
    //     processResults: function (data, params) {
    //       if (data.options && data.options.length > 0) {
    //         return {
    //           results: data.options.map((item, index) => ({
    //             id: item.value, // ✅ Add prefix to the ID
    //             value: item.value,
    //             text: item.label,
    //           })),
    //         };
    //       } else {
    //         return { results: [] }; // 👈 empty so that createTag is triggered
    //       }
    //     },
    //     cache: true,
    //   },
    //   placeholder: "Search PE/VC",
    //   allowClear: true,
    //   minimumInputLength: 2,
    //   language: function () {
    //     return "";
    //   },
    //   escapeMarkup: (markup) => markup,
    // });

    // $select2.on("select2:select", async (e) => {
    //   const selectedData = e.params.data;
    //   console.log(selectedData);
    //   if (selectedData.custom === true) {
    //     // Use the raw typed value for the form
    //     $select2.val(selectedData.id).trigger("change.select2"); // no append needed
    //     setValue("companyinfo_id", selectedData.text);
    //   } else {
    //     $select2.val(selectedData.id).trigger("change.select2"); // no append needed
    //     setValue("companyinfo_id", selectedData.id);
    //   }
    // });

    // $select2.on("select2:clear", function () {
    //   $select2.find("option").remove(); // remove all options
    //   $select2.val(null).trigger("change.select2");
    //   setValue("companyinfo_id", "");
    // });

    // return () => {
    //   $select2.off("change");
    // };
  }

  const setpeVcReferredOption = (e) => {
    const peVcReferredOption = e;
    setValue("private_equity", peVcReferredOption);
    setpeVcReferred(peVcReferredOption);
  };

  const showgroupedCompanyOther = (e) => {
    const groupedCompanyOther = e;
    if (groupedCompanyOther == 0) {
      setshowOthergroupedCompany(true);
    } else {
      setshowOthergroupedCompany(false);
    }
  };

  return (
    <div className="modal fade show d-block add_client" tabIndex="-1">
      <div
        className="modal-dialog modal-dialog-centered modal-md add_client_modal"
        role="document"
      >
        <div className="modal-content">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-header">
              <h4 className="modal-title">
                Edit Client
                <span style={{ marginLeft: "20px" }}>
                  <button type="button" className="btn btn-primary my-1 me-2">
                    Reference Id{" "}
                    <span className="badge ms-2 bg-secondary">
                      {existClient?.company?.reference}
                    </span>
                  </button>
                </span>
              </h4>

              <button
                type="button"
                className="btn-close custom-btn-close"
                onClick={() => {
                  clearSelect();
                  onClose?.();
                }}
              >
                <i className="ti ti-x"></i>
              </button>
            </div>

            <div className="modal-body row" style={{ padding: "30px" }}>
              <div className="col-xl-6">
                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Company *{" "}
                    {errors.companies && (
                      <span className="text-danger">
                        {errors.companies.message}
                      </span>
                    )}
                  </label>
                  <input type="hidden" {...register("reference")} />
                  <input type="hidden" {...register("id")} />
                  <input
                    type="text"
                    className="form-control"
                    {...register("companies", { required: "required" })}
                  />
                </div>

                {/* Major Industry */}
                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Major Industry *{" "}
                    {errors.industrymaster_id && (
                      <span className="text-danger">
                        {errors.industrymaster_id.message}
                      </span>
                    )}
                  </label>
                  <select
                    {...register("industrymaster_id", {
                      required: "required",
                    })}
                    onChange={(e) => fetchMinorIndustry(e)}
                    className="form-select"
                  >
                    <option value="">Select</option>
                    {majorIndustries.map((m) => (
                      <option key={m.id} value={Number(m.id)}>
                        {m.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Grouped Company Option */}
                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Is this entity part of a larger corporate group? *{" "}
                    {errors.groupedCompanyOption && (
                      <span className="text-danger">
                        {errors.groupedCompanyOption.message}
                      </span>
                    )}
                  </label>
                  <select
                    {...register("groupedCompanyOption", {
                      required: "required",
                    })}
                    className="form-select"
                  >
                    <option value="no">No, this is an independent company</option>
                    <option value="yes">Yes, this entity belongs to a parent company/group</option>
                  </select>
                  {groupedCompanyOption === "yes" && (
                    <>
                      <label className="form-label mt-2">
                        Parent Company / Group:
                        {errors.groupedCompany && (
                          <span className="text-danger">
                            {errors.groupedCompany.message}
                          </span>
                        )}
                      </label>
                      <select
                        {...register("groupedCompany", {
                          required: "required",
                        })}
                        onChange={(e) =>
                          showgroupedCompanyOther(e.target.value)
                        }
                        className="form-select mt-2"
                      >
                        <option value="">Select</option>
                        {companies.map((c) => (
                          <option key={c.id} value={Number(c.id)}>
                            {c.name}
                          </option>
                        ))}
                        <option value={0}>other</option>
                      </select>
                      {showOthergroupedCompany && (
                        <>
                          <span>
                            {errors.groupedCompanyOther && (
                              <span className="text-danger">
                                {errors.groupedCompanyOther.message}
                              </span>
                            )}
                          </span>
                          <input
                            type="text"
                            {...register("groupedCompanyOther", {
                              required: "required",
                            })}
                            placeholder="Enter Grouped Company Name"
                            className="form-control mt-2"
                          />
                        </>
                      )}
                    </>
                  )}
                </div>

                {/* Client Type (disabled input) */}
                <div className="row mb-3 me-3">
                  <label className="form-label">Client Type* </label>
                  <select className="form-select" {...register("clientType")}>
                    {clientTypes.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.type}
                      </option>
                    ))}
                  </select>
                </div>
                {/* Business Developed By */}
                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Business Developed By*{" "}
                    {errors.businessDeveloped_id && (
                      <span className="text-danger">
                        {errors.businessDeveloped_id.message}
                      </span>
                    )}
                  </label>
                  <select
                    {...register("businessDeveloped_id", {
                      required: "required",
                    })}
                    className="form-select"
                  >
                    <option value="">Select</option>
                    {users.length > 0 &&
                      users.map((item, index) => (
                        <option
                          key={index}
                          value={Number(item.id)}
                        >{`${item.firstname} ${item.lastname}`}</option>
                      ))}
                  </select>
                </div>
                {/* BD Influence */}
                <div className="row mb-3 me-3">
                  <label className="form-label">BD Influence</label>
                  <select {...register("bdInfluence")} className="form-select">
                    <option value="">Select</option>
                    {users.length > 0 &&
                      users.map((item, index) => (
                        <option
                          key={index}
                          value={Number(item.id)}
                        >{`${item.firstname} ${item.lastname}`}</option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-xl-6">
                {/* Website */}
                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Website*{" "}
                    {errors.website && (
                      <span className="text-danger">
                        {errors.website.message}
                      </span>
                    )}
                  </label>
                  <input
                    type="url"
                    {...register("website", {
                      required: "required",
                    })}
                    placeholder="https://www.example.com"
                    className="form-control"
                  />
                </div>
                {/* Minor Industry */}
                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Minor Industry*{" "}
                    {errors.industry_id && (
                      <span className="text-danger">
                        {errors.industry_id.message}
                      </span>
                    )}
                  </label>
                  <select
                    {...register("industry_id", {
                      required: "required",
                    })}
                    className="form-select"
                  >
                    <option value="">Select</option>
                    {minorIndustries.length > 0 &&
                      minorIndustries.map((m) => (
                        <option key={m.id} value={Number(m.id)}>
                          {m.name}
                        </option>
                      ))}
                  </select>
                </div>
                {/* PE/VC Referred Option */}
                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Does this entity have an investor relationship?*{" "}
                    {errors.private_equity && (
                      <span className="text-danger">
                        {errors.private_equity.message}
                      </span>
                    )}
                  </label>
                  <select
                    {...register("private_equity", {
                      required: "required",
                      value: "no",
                    })}
                    onChange={(e) => setpeVcReferredOption(e.target.value)}
                    className="form-select"
                  >
                    <option value="no">No</option>
                    <option value="yes">Yes, this entity is a PE/VC firm or is a portfolio company of a PE/VC firm</option>
                  </select>
                  {peVcReferred === "yes" && (
                    <span className="mt-2" style={{ padding: "0" }}>
                      <label className="form-label mt-2">
                        Investor / PE / VC Firm
                         {errors.peVcReferred && (
                            <span className="text-danger">
                              {errors.peVcReferred.message}
                            </span>
                          )}
                      </label>
                      {/* <select
                        {...register("companyinfo_id", {
                          required: "required",
                        })}
                        className="select2 form-select mt-2"
                      >
                        <option value="">Select</option>
                      </select> */}
                      <Select
                        className="react-select"
                        options={companyInfoOptions}
                        value={selectedCompanyInfo}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        onInputChange={(value, actionMeta) => {
                          if (actionMeta.action === "input-change") {
                            // hide selected value while searching
                            if (value.trim() !== "") {
                              setSelectedCompanyInfo(null);
                            } else {
                              // restore old selected if input cleared
                              setSelectedCompanyInfo(lastSelectedRef.current);
                            }

                            // debounce api
                            if (searchTimeout.current) {
                              clearTimeout(searchTimeout.current);
                            }

                            searchTimeout.current = setTimeout(() => {
                              if (value.trim() !== "") {
                                PEPV(value.trim());
                              }
                            }, 500);
                          }
                        }}
                        onChange={async (option) => {
                          setSelectedCompanyInfo(option);
                          setValue("companyinfo_id", option.value);
                          lastSelectedRef.current = option;
                        }}
                      />
                    </span>
                  )}
                </div>
                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Is this entity a Global Capability Center (GCC){" "}
                    <span className="fs-8">[ e.g. Is this a part of GCC]</span>
                  </label>
                  <select
                    {...register("gcc", { value: "no" })}
                    className="form-select"
                  >
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>

                {/* Origin */}
                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Head Quarters*{" "}
                    {errors.origin && (
                      <span className="text-danger">
                        {errors.origin.message}
                      </span>
                    )}
                  </label>
                  <select
                    {...register("origin", { required: "required" })}
                    className="form-select"
                  >
                    <option value="">Select</option>
                    {countries.map((c) => (
                      <option key={c.name} value={Number(c.id)}>
                        {c.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Client Managed By */}
                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Client Managed By*{" "}
                    {errors.clientManaged_id && (
                      <span className="text-danger">
                        {errors.clientManaged_id.message}
                      </span>
                    )}
                  </label>
                  <select
                    {...register("clientManaged_id", {
                      required: "required",
                    })}
                    className="form-select"
                  >
                    <option value="">Select</option>
                    {users.length > 0 &&
                      users.map((item, index) => (
                        <option
                          key={index}
                          value={Number(item.id)}
                        >{`${item.firstname} ${item.lastname}`}</option>
                      ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="modal-footer" style={{ justifyContent: "center" }}>
              <button type="submit" className="btn btn-primary me-2">
                Save Client
              </button>

              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  clearSelect();
                  onClose?.();
                }}
              >
                Close
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default EditClient;
